import { FC } from 'react';
import Button from 'components/Button';
import { useLaunchPortalImpersonation } from 'hooks/data/impersonationAccess/useLaunchPortalImpersonation';

type Props = {
  investorId: string;
  firmDomain: string;
};

const LaunchPortalButton: FC<Props> = ({ investorId, firmDomain }) => {
  const launchPortalImpersonation = useLaunchPortalImpersonation();

  return (
    <Button
      color="primary"
      variant="contained"
      size="small"
      loading={launchPortalImpersonation.isPending}
      onClick={() =>
        launchPortalImpersonation.investor({
          investorId,
          firmDomain,
        })
      }
    >
      View investor portal
    </Button>
  );
};

export default LaunchPortalButton;
